<template>
    <div class="list-simple" >
       
        <div v-if="list.length==0" class="no-data">
            暂无文章
        </div>
        <el-row :gutter="10">
            <el-col :span="8">
                <template v-if="imageList.length>=1">
                    <router-link :to="'/article/'+imageList[0].article_id" target="_blank"> 
                     <div class="img" :style="'height:80px;background-image:url('+(imageList[0].first_img==''?'static/img/nopic.gif':imageList[0].first_img)+')'">
                    </div>
                    <div class="first-title am-text-truncate">{{imageList[0].title}}</div>
                    </router-link>
                   
                </template>
                <template v-if="imageList.length>=2">
                    <router-link :to="'/article/'+imageList[1].article_id" target="_blank"> 
                     <div class="img" :style="'height:80px;background-image:url('+(imageList[1].first_img==''?'static/img/nopic.gif':imageList[1].first_img)+')'">
                    </div>
                    <div class="first-title am-text-truncate">{{imageList[1].title}}</div>
                    </router-link>
                   
                </template>
                 
            </el-col>
             <el-col :span="16">
                <ul >
                    <li class="am-cf" v-for="(item,index) in list" :key="index"  >
                        <div class="title am-text-truncate" :style="date?'':'width:100%'">
                            <el-tag size="mini" v-if="item.port_new=='1'">新</el-tag>
                            <el-tag size="mini" v-if="item.port_top=='1'" type="danger">顶</el-tag>
                            <router-link :to="'/article/'+item.article_id" target="_blank">{{item.title}}</router-link>
                        </div>
                        <div class="date" v-if="date">
                            {{(item.publish_time||'').substring(5,10)}}
                        </div>
                    </li>
                </ul>
            </el-col>

        </el-row>
        
    </div>
</template>

<script>
export default {
    props:{
        list:{
            type:Array,
        },
        date:{
            default:true
        }
    },
    computed:{
        imageList(){
            return this.list.filter(e=>{
                return !!e.first_img
            })
        }
    }
}
</script>

<style lang="scss">
.list-simple{
    .first-title{
        margin-bottom: 8px;
        font-size: 12px;
        text-align: center;
    }
    li{
        background-repeat: no-repeat;
        background-position: left;
        font-size: 14px;
        height: 28px;
        line-height: 28px;
        &:hover{
            color: $primary;
        }
        .title{
            width: calc(100% - 100px);
            float: left;
        }
        .date{
            width: 100px;
            float: left;
            text-align: right;
            padding-left: 20px;
            box-sizing: border-box;
        }
    }
}
</style>
